import {Inject, Injectable} from '@angular/core';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {filter, map, switchMap} from 'rxjs/operators';
import {
    MxInformationTooltipConfig,
    MxInformationService,
    getHttpWithoutCors,
    MxApplicationPropertiesService,
    MX_APPLICATION_PROPERTY_SERVICE_TOKEN
} from 'mx-core';

@Injectable({
    providedIn: 'root'
})
export class PrlInformationService implements MxInformationService {

    private _infoConfigs$$: BehaviorSubject<Map<String, MxInformationTooltipConfig>>
        = new BehaviorSubject<Map<String, MxInformationTooltipConfig>>(new Map<String, MxInformationTooltipConfig>());


    constructor(@Inject(MX_APPLICATION_PROPERTY_SERVICE_TOKEN) private applicationProperties: MxApplicationPropertiesService) {
    }

    init(): Observable<void> {
        // this.applicationProperties.getProperty('portal.information_tooltip.url')
        //     .pipe(
        //         switchMap(url => {
        //             if (url) {
        //                 return getHttpWithoutCors<Map<String, MxInformationTooltipConfig>>(url);
        //             } else {
        //                 return of(void 0);
        //             }
        //         })
        //     ).subscribe(value =>  this._infoConfigs$$.next(new Map<String, MxInformationTooltipConfig>(value)));
        return of(void 0);
    }


    getInformationConfigs(key: string): Observable<MxInformationTooltipConfig> {
      if (key) {
        return this._infoConfigs$$.pipe(
            filter(value => value.has(key)),
            map(value => value.get(key)));
      } else {
        of(void 0);
      }
    }

    getUserGuideLink(): string {
        return '/CHANGE_ME';
    }

}
